import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, FORM_FIELDS_TYPES, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue, NonRequired } from 'src/lib/validation/ValidationTypes';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import PruefAssistenz from '../../../../../../antrag-components/PruefAssistenz';
import ApplicationHeading from '../../../../../../application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from '../../../../../../application-helper-function/AppHelperfunctions';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

const BeschreibungVorhabensForschungAntragEmobFundE: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	return (
		<>
			<ApplicationHeading title='Beschreibung des Vorhabens' description={PLATZHALTER_TEXT} />

			<PruefAssistenz
				statusPath={
					P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0089835347_rhabens_Pruefung_Pruefstatus.path
				}
				hinweisPath={
					P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0096703458_nweis_Fuer_Den_Antragsteller.path
				}
				ueberarbeitetAmPath={
					P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0099269789_ns_Pruefung_Ueberarbeitet_Am.path
				}
				erledigtPath={
					P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0106506068_Vorhabens_Pruefung_Erledigt.path
				}
				formStruc={formStrucPruefAssistenz()}
			/>

			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={updatedReadOnly} />
		</>
	);
};
export default BeschreibungVorhabensForschungAntragEmobFundE;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0106506068_Vorhabens_Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0175233205_Erwartete_Projektergebnisse,
				{
					...P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0020380398_ojektergebnisse_Kundennutzen,
					label: 'Innovationsgrad / Alleinstellungsmerkmale der Projektergebnisse / Kundennutzen - Beschreibung',
				},
				{
					...P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0178136770_reibung_Des_Vorhabens_Bilder,
					tableLabel: 'Bildmaterial zur Beschreibung des Vorhabens (optional)',
					type: FORM_FIELDS_TYPES.editableTable,
					fieldProps: { Bild: { allowOnlyImage: true } },
				},
				P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0165557413_ten_Und_Entwicklungsschritte,
				P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0097279566_Partnerbei_Verbundprojekten,
				{
					...P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0000855781_ibung_Des_Vorhabens_Anhaenge,
					allowOnlyImage: true,
					validation: [{ validateFunction: NonRequired }],
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucBeschreibungVorhabensForschungAntragEmobFundE = (application: any) => {
	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0089835347_rhabens_Pruefung_Pruefstatus.path,
			P.Projektbeschreibung_Elektromobilitaet_FE.schema.attributes.Projektbeschreibung_Elek_0106506068_Vorhabens_Pruefung_Erledigt.path,
		)
	)
		return concat(formStrucPruefAssistenz(), formStruc());
	else return concat(formStruc());
};
